// delete this file when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled

export const urls = {
	set: '/rest/jpo/1.0/pluginUserProperties/set',
} as const;

export const setUserPropertyBody = (key: string, value: boolean) => ({
	key,
	value,
});
